import "./EnergyCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import Principles from "./sections/Principles";
import Heroenergia from "./sections/Heroenergia";
import Industrialcasestudydetail from "./sections/Industrialcasestudydetail";
import Footer from "@/reusable_sections/Footer";
export default function EnergyCaseStudyPage() {
  return <div>
      <Header />
      
      <Principles />
      <Heroenergia />
      <Industrialcasestudydetail />
      <Footer />
    </div>;
}